import { render } from "./SegmentStatusList.vue?vue&type=template&id=78ba8cdf"
import script from "./SegmentStatusList.vue?vue&type=script&lang=js"
export * from "./SegmentStatusList.vue?vue&type=script&lang=js"

import "./SegmentStatusList.vue?vue&type=style&index=0&id=78ba8cdf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__